import React from 'react';
import { Card, Typography } from '@curves/ui-base';
import { ScrollableTable } from '@curves/ui-shared';

import {parseDate} from '@Util/moment.util';
import {DATE_TIME_STANDARD} from '@Constants/appConfig';
import {formatCurrencyFn} from '@Util/utils';
const headerRow = [
    {
        cellKey: "orderNo",
        headerLabel: "訂單編號",
        minWidth: 200,
    },
    {
        cellKey: "createdDate",
        headerLabel: "日期",
        minWidth: 50,
        formatCell: (v) => parseDate(v, DATE_TIME_STANDARD.DISPLAYDATEBYSLASH)
    },
    {
        cellKey: "payablePrice",
        headerLabel: "應開金額",
        minWidth: 50,
        align: "right",
        formatCell: (v) => formatCurrencyFn(v, {symbol: '$'})
    },
    {
        cellKey: "orderStatusText",
        headerLabel: "訂單狀態",
        minWidth: 50,
    }
];
const OrderInfoSection = ({ className, invoiceNo, salesAmount, orderList = []}) => {
    const orderLength = orderList?.length || 0;
    return (
        <Card className={className}>
            <Card.CardHeader title={'訂單明細'} />
            <Card.CardContent className="px-2 pb-3 pt-0">
                <Typography variant={'body2'} className={'font-color-3'}>
                    <span className={'pr-2'}>原發票號碼：{invoiceNo || '查無資料'}</span>
                    <span className={'pr-2'}>訂單數：{orderLength}</span>
                    {/* todo: 接發票金額 */}
                    <span>合計金額：{formatCurrencyFn(salesAmount, {symbol: '$'})}</span>
                </Typography>
                <ScrollableTable
                    headerRow={headerRow}
                    rowsData={orderList}
                    cardProps={{ className: 'theme-gray' }}
                />
            </Card.CardContent>
        </Card>
    )
};
export default OrderInfoSection;
